import {
    useEffect,
    useRef,
    type FC
} from "react";
import {
    Animated
} from "react-native";
import type IMessageScrollerTargetProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    getMotionDuration,
    useReducedMotion,
    MOTION_EASINGS
} from "../../../../helpers/motion";
import {
    useMessageScrollerSelector,
    useMessageScrollerContext
} from "../../context";

const MessageScrollerTarget: FC<IMessageScrollerTargetProps> = ({
    customTheme,
    messageId
}) => {
    const context = useMessageScrollerContext();

    const {
        shapeConfigs,
        durations,
        radiuses,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const isReduced = useReducedMotion();

    const isActive = useMessageScrollerSelector(context, (snapshot) => snapshot.highlightedId === messageId, false);

    const opacity = useRef(new Animated.Value(1)).current;

    const {
        container: containerDynamicStyle
    } = useStyles({
        shapeConfigs,
        radiuses,
        colors,
        spaces
    });

    useEffect(() => {
        if(!isActive) {
            return;
        }

        opacity.setValue(1);

        const animation = Animated.sequence([
            Animated.delay(durations.breathe),
            Animated.timing(opacity, {
                duration: getMotionDuration({
                    isReduceMotionEnabled: isReduced,
                    duration: "long",
                    motion: "fade",
                    durations
                }),
                easing: MOTION_EASINGS.exit,
                useNativeDriver: false,
                isInteraction: false,
                toValue: 0
            })
        ]);

        animation.start();

        return () => {
            animation.stop();
        };
    }, [
        isReduced,
        durations,
        isActive,
        opacity
    ]);

    if(!isActive) {
        return null;
    }

    return <Animated.View
        style={[
            stylesheet.container,
            containerDynamicStyle,
            {
                opacity
            }
        ]}
        aria-hidden={true}
    />;
};
export default MessageScrollerTarget;
